export default __webpack_public_path__ + "static/media/resumed-sequence-play.21818a93.svg";